<template>
  <v-container fluid class="pa-5 pb-16 elevation-1 profile-page">
    <v-sheet
      class="pa-4 w-100 app-header"
      color="#194c9b"
      elevation="2"
      rounded
    >
      <h1 class="text-h4 font-weight-bold d-flex align-center">
        <div class="header-content">
          <v-btn icon elevation="2" color="blue">
            <v-icon color="white">mdi-account-circle</v-icon>
          </v-btn>
          <span class="header-title">{{ $t("perfil") }}</span>
        </div>

        <v-spacer />

        <v-chip v-if="loading" size="small" color="white" variant="outlined">
          {{ $t("cargando") }}
        </v-chip>

        <v-btn
          icon
          variant="text"
          @click="fetchMe"
          :loading="loading"
          class="ml-2"
        >
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </h1>
    </v-sheet>

    <v-card class="mt-4">
      <v-card class="cool-card profile-panel">
        <v-form ref="form" @submit.prevent="saveAll">
          <v-row class="profile-grid" no-gutters>
            <v-col cols="12" md="4" class="profile-left">
              <div class="profile-avatar-wrap">
                <v-avatar size="168" class="profile-avatar">
                  <!-- esta linea es para local -->
                   <!-- :src="photoPreview || me.photoUrl" -->
                  <v-img
                    v-if="photoPreview || me.photoUrl"
                    :src="photoPreview || me.photoUrl"
                    cover
                  />
                  <v-icon v-else size="120" color="white"
                    >mdi-account-circle</v-icon
                  >
                </v-avatar>
              </div>

              <div class="profile-photo-actions">
                <div class="text-subtitle-2 font-weight-medium mb-2">
                  {{ $t("foto") }}
                </div>

                <div class="d-flex align-center ga-2">
                  <v-file-input
                    v-model="photoFile"
                    accept="image/*"
                    prepend-icon="mdi-camera"
                    :label="$t('subirfoto') || 'Subir foto'"
                    variant="outlined"
                    density="comfortable"
                    hide-details
                    :show-size="true"
                    class="profile-file"
                    @update:modelValue="onPhotoSelected"
                  />

                  <v-btn
                    variant="tonal"
                    color="error"
                    :disabled="!me.photoUrl && !photoPreview"
                    @click="removePhotoHandler"
                    prepend-icon="mdi-trash-can-outline"
                    class="profile-remove"
                  >
                    {{ $t("quitar") || "Quitar" }}
                  </v-btn>
                </div>

                <div class="text-caption text-medium-emphasis mt-2">
                  {{ $t("photo_rules") }}
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="8" class="profile-right">
              <div class="profile-section">
                <div class="profile-section-title">{{ $t("datos") }}</div>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="me.first_name"
                      name="first_name"
                      :label="$t('nombre')"
                      :placeholder="$t('placeholder_nombre')"
                      required
                      variant="outlined"
                      density="comfortable"
                      :rules="[validateFields]"
                      prepend-inner-icon="mdi-account"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="me.last_name"
                      name="last_name"
                      :label="$t('apellidos')"
                      :placeholder="$t('placeholder_apellidos')"
                      required
                      variant="outlined"
                      density="comfortable"
                      :rules="[validateFields]"
                      prepend-inner-icon="mdi-account-badge-outline"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="me.username"
                      name="username"
                      :label="$t('nombreuser')"
                      :placeholder="$t('placeholder_username')"
                      variant="outlined"
                      density="comfortable"
                      :rules="[validateFields]"
                      prepend-inner-icon="mdi-at"
                      :readonly="true"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="me.email"
                      name="email"
                      type="email"
                      :label="$t('correo')"
                      :placeholder="$t('placeholder_email')"
                      required
                      variant="outlined"
                      density="comfortable"
                      :rules="[validateFields]"
                      prepend-inner-icon="mdi-email-outline"
                    />
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="me.unidad"
                      name="unidad"
                      label="Unidad de negocio"
                      variant="outlined"
                      density="comfortable"
                      prepend-inner-icon="mdi-office-building-outline"
                      readonly
                      persistent-placeholder
                      placeholder="Sin unidad asignada"
                    />
                  </v-col>
                </v-row>
              </div>

              <v-divider class="my-8" />

              <div class="profile-section">
                <div class="profile-section-title">
                  {{ $t("seguridad") || "SEGURIDAD" }}
                </div>

                <v-switch
                  v-model="changePassword"
                  :label="$t('cambiarpass') || 'Cambiar contraseña'"
                  inset
                />

                <template v-if="changePassword">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="currentPassword"
                        name="currentPassword"
                        :label="$t('passActual') || 'Contraseña actual'"
                        type="password"
                        required
                        variant="outlined"
                        density="comfortable"
                        :rules="[validateFields]"
                        prepend-inner-icon="mdi-lock-outline"
                      />
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="newPassword"
                        name="newPassword"
                        :label="$t('password') || 'Nueva contraseña'"
                        type="password"
                        required
                        variant="outlined"
                        density="comfortable"
                        :rules="[validatePassword]"
                        prepend-inner-icon="mdi-lock-plus-outline"
                      />
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="confirmPassword"
                        name="confirmPassword"
                        :label="$t('confirmPass')"
                        type="password"
                        required
                        variant="outlined"
                        density="comfortable"
                        :rules="[passwordMatchRule]"
                        prepend-inner-icon="mdi-lock-check-outline"
                      />
                    </v-col>

                    <v-col cols="12" sm="6" class="d-flex align-center">
                      <div class="w-100">
                        <p class="mb-2">
                          <strong>{{ $t("nota") }}</strong>
                        </p>
                        <v-list
                          density="compact"
                          class="pa-0"
                          style="background: transparent"
                        >
                          <v-list-item
                            class="pa-0"
                            v-for="(rule, index) in passwordRules"
                            :key="index"
                          >
                            <v-icon color="success" v-if="rule.valid"
                              >mdi-check-circle</v-icon
                            >
                            <v-icon color="error" v-else
                              >mdi-close-circle</v-icon
                            >
                            <span class="ml-2">{{ rule.message }}</span>
                          </v-list-item>
                        </v-list>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </div>

              <!-- Seguridad: verificacion en dos pasos (2FA) -->
              <v-divider class="my-6" />
              <div class="profile-section">
                <div class="profile-section-title">
                  Verificación en dos pasos (2FA)
                </div>
                <p class="text-body-2 text-medium-emphasis mb-3">
                  Restablece tu 2FA para cambiar de dispositivo. En tu próximo
                  inicio de sesión se te pedirá escanear un QR nuevo.
                </p>
                <v-btn
                  type="button"
                  color="primary"
                  variant="tonal"
                  prepend-icon="mdi-cellphone-key"
                  :loading="disablingMfa"
                  @click="desactivarMfa"
                >
                  Restablecer 2FA (cambiar dispositivo)
                </v-btn>
              </div>

              <div class="profile-actions">
                <v-btn
                  type="submit"
                  color="primary"
                  elevation="5"
                  :disabled="!formIsValid || loading"
                  :loading="loading"
                  prepend-icon="mdi-content-save"
                  class="profile-save-btn"
                >
                  {{ $t("guardar") }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { swal } from "@/utils/swal";
import { useSettingsStore } from "@/stores/settings";
import { mfaDisable } from "@/api/mfa.js";

import {
  getMe,
  updateMe,
  changeMyPassword,
  uploadMyPhoto,
  removeMyPhoto,
} from "@/api/profile.js";

export default {
  name: "PerfilUsuario",

  data() {
    return {
      loading: false,
      defaultAvatar: "",

      me: {
        username: "",
        email: "",
        first_name: "",
        last_name: "",
        photoUrl: "",
        unidad: "",
      },

      originalMe: null,

      photoFile: null,
      photoPreview: "",
      removePhotoFlag: false,

      changePassword: false,
      disablingMfa: false,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
  },

  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },

    passwordRules() {
      return [
        { message: this.$t("rulepass1"), valid: this.newPassword?.length >= 8 },
        {
          message: this.$t("rulepass2"),
          valid: /[A-Z]/.test(this.newPassword),
        },
        { message: this.$t("rulepass3"), valid: /\d/.test(this.newPassword) },
        {
          message: this.$t("rulepass4"),
          valid: /[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword),
        },
      ];
    },

    isPasswordValid() {
      return this.passwordRules.every((rule) => rule.valid);
    },

    formIsValid() {
      const baseOk =
        this.me.first_name &&
        this.me.last_name &&
        this.me.username &&
        this.me.email;

      if (!baseOk) return false;

      if (this.changePassword) {
        return (
          this.currentPassword &&
          this.newPassword &&
          this.confirmPassword === this.newPassword &&
          this.isPasswordValid
        );
      }
      return true;
    },

    validateFields() {
      return (value) => {
        if (!value) return this.$t("obligatorio");
        return true;
      };
    },

    validatePassword() {
      return (value) => {
        if (!value) return this.$t("obligatorio1");
        return true;
      };
    },

    passwordMatchRule() {
      return (value) => {
        if (value !== this.newPassword) return this.$t("coinc");
        return true;
      };
    },
  },

  mounted() {
    this.fetchMe();
  },

  methods: {
    // Desactiva la verificacion en dos pasos (2FA) pidiendo la contraseña.
    async desactivarMfa() {
      const popup = {
        popup: this.isDark ? "mi-popup" : "mi-popup-2",
        title: "mi-titulo",
      };
      const { value: password, isConfirmed } = await swal({
        title: "Restablecer 2FA",
        text: "Esto borrará tu dispositivo actual. En tu próximo inicio de sesión deberás escanear un QR nuevo. Ingresa tu contraseña para confirmar.",
        input: "password",
        inputPlaceholder: "Contraseña",
        showCancelButton: true,
        confirmButtonText: "Restablecer",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#2563EB",
        cancelButtonColor: "#6B7280",
        customClass: popup,
      });
      if (!isConfirmed || !password) return;

      this.disablingMfa = true;
      try {
        await mfaDisable(password);
        await swal({
          icon: "success",
          title: "2FA restablecido",
          text: "En tu próximo inicio de sesión escanea el QR nuevo.",
          confirmButtonColor: "#2563EB",
          customClass: popup,
        });
      } catch (e) {
        await swal({
          icon: "error",
          title: "Error",
          text:
            e?.response?.data?.detail ||
            e?.response?.data?.error ||
            "No se pudo desactivar la 2FA.",
          customClass: popup,
        });
      } finally {
        this.disablingMfa = false;
      }
    },
    async fetchMe() {
      try {
        this.loading = true;
        const data = await getMe();
        console.log("SSSS", data)
        this.me.username = data.username ?? "";
        this.me.email = data.email ?? "";
        this.me.first_name = data.first_name ?? "";
        this.me.last_name = data.last_name ?? "";
        // Unidad / cliente al que pertenece (tolerante al nombre del campo).
        this.me.unidad =
          data.nameUnitBussines ??
          data.unidad_nombre ??
          data.unidad ??
          data.cliente ??
          "";
        if (data.photoUrl.includes("https")){
          this.me.photoUrl = data.photoUrl
        }else{
           this.me.photoUrl = this.toRelativeUrl(data.photoUrl);
           console.log("me.photoUrl asignado →", this.me.photoUrl);
           
        }
       console.log("rrr",this.me.photoUrl)
       // console.log("me.photoUrl asignado →", this.me.photoUrl);
        this.$nextTick(() => this.$refs.form?.resetValidation());

        await swal({
          icon: "success",
          title: this.$t("perfil_cargado") || "Perfil cargado",
          timer: 1200,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } catch (e) {
       await swal({
          icon: "error",
          title: this.$t("profile_load_error"),
          timer: 2200,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    toRelativeUrl(url) {
  if (!url) return "";
  try {
    const u = new URL(url, window.location.origin);
    return u.pathname + u.search;   // → /media/profile_photos/foo.jpg
  } catch {
    return url;                      // ya era relativa
  }
},

    onPhotoSelected(file) {
      const f = Array.isArray(file) ? file[0] : file;
      if (!f) {
        this.photoPreview = "";
        return;
      }
      this.removePhotoFlag = false;
      this.photoPreview = URL.createObjectURL(f);
    },

    async removePhotoHandler() {
      try {
        this.loading = true;
        this.photoFile = null;
        this.photoPreview = "";
        this.removePhotoFlag = true;

        const resp = await removeMyPhoto();
        this.me.photoUrl = resp.photoUrl || "";

        await swal({
          icon: "success",
          title: this.$t("photo_deleted"),
          timer: 1800,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } catch (error) {
        await swal({
          icon: "error",
          title: this.$t("photo_delete_error"),
          timer: 2200,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } finally {
        this.loading = false;
      }
    },

    async saveAll() {
      try {
        this.loading = true;

        await updateMe({
          username: this.me.username,
          email: this.me.email,
          first_name: this.me.first_name,
          last_name: this.me.last_name,
        });

        if (this.changePassword) {
          await changeMyPassword({
            currentPassword: this.currentPassword,
            newPassword: this.newPassword,
            confirmPassword: this.confirmPassword,
          });
        }

        if (this.photoFile) {
          const resp = await uploadMyPhoto(this.photoFile);
          this.me.photoUrl = resp.photoUrl || this.me.photoUrl;
        }

        await swal({
          icon: "success",
          title: this.$t("profile_updated"),
          timer: 2000,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });

        this.$refs.form.resetValidation();
        await this.fetchMe();
      } catch (error) {
        const data = error?.response?.data;

        let msg = this.$t("save_error");
        if (data && typeof data === "object") {
          const k = Object.keys(data)[0];
          msg = Array.isArray(data[k]) ? data[k][0] : data[k];
        }

        await swal({
          icon: "error",
          title: msg,
          timer: 2500,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
:deep(.v-theme--dark .cool-card.profile-panel) {
  background: rgba(17, 24, 39, 0.88) !important;
  backdrop-filter: blur(10px);
}

:deep(.v-theme--light .cool-card.profile-panel) {
  background: rgba(255, 255, 255, 0.92) !important;
  backdrop-filter: blur(10px);
}

:deep(.cool-card.profile-panel:hover) {
  transform: none !important;
}

.profile-panel {
  padding: 26px 26px;
  border-radius: 22px;
}

.profile-left {
  padding-right: 18px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

:deep(.v-theme--light .profile-left) {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
}

.profile-avatar {
  border: 3px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);
}

:deep(.v-theme--light .profile-avatar) {
  border: 3px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.profile-section-title {
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  opacity: 0.85;
  margin-bottom: 12px;
}

.profile-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 18px;
}

.profile-save-btn {
  min-width: 260px;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
}
:deep(.profile-panel .v-divider) {
  margin: 32px 0;
}
</style>
